angular.module('impactx.cancellation').controller('CRHSupplierListCtrl', CRHSupplierListCtrl);

CRHSupplierListCtrl.$inject = ['selectedListItems'];

function CRHSupplierListCtrl(selectedListItems)
{
    var self = this;

    self.getDetailLink = function () {
        return 'crhdetailssupplier/' + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'CancellationRequestSupplier'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/cancellation/templates/crhlistsupplier.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/cancellationrequest/list/supplier',
        id: "crhlistsupplier",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}